import Layout4Main from "components/layout/Layout4Admin";
import { Row, Col, Form, Button, Tab, Table, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Css from './Customer.module.css';
import ApiConection from 'api_ref/ApiConection';
import { useEffect, useState } from "react";
import moment from "moment";
import { AddCommar, ConvertDateTimeToText, DisplayPaging } from "components/MyControl";
import GenPaging from "components/Paging";
import Layout4Admin1 from "components/layout/Layout4Admin1";
import Footer4Bottom1 from "components/layout/Foot4Bottom1";
const arr_table = [
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Overdue', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' },
    { invoice_number: '109912', customer_name: 'บริษัท เอบี.จำกัด', due_date: '05/12/2023', status: 'Paid', plan: 'Profressional', invoice_amount: '1,990', payment_type: 'Credit/Debit Card', transaction_date: '2022-10-04 09:00:00' }
]

export default function PayPending() {
    const navigate = useNavigate();

    const api = new ApiConection();

    const [loading, setLoading] = useState(false);
    const [dataList, setDataList] = useState([]);
    const [condition, setCondition] = useState({
        is_audit: '',
        active: true
    });
    const [pagination, setPagination] = useState({
        record_start: 0,
        record_end: 0,
        record_count: 0,
        page_count: 0
    })
    const [search, setSearch] = useState({
        page: 1,
        size: 10
    })

    const getQuontation = async () => {
        let data = {
            search: condition,
            pagination: {
                size: search.size,
                page: search.page,
                orderby: "QuontationNumber",
                ordermode: "desc"
            }
        }
        //console.log(data);

        setLoading(true);

        const response_paging = await api.postData(`api/Quontation/pagination`, data);
        if (response_paging.status === true) {
            handleSetPagination('record_start', response_paging.data.record_start);
            handleSetPagination('record_count', response_paging.data.record_count);
            handleSetPagination('page_count', response_paging.data.page_count);

            let record_end = response_paging.data.record_start + (search.size - 1);
            if (record_end > response_paging.data.record_count) {
                record_end = response_paging.data.record_count;
            }

            handleSetPagination('record_end', record_end);
        }

        const response = await api.postData(`api/Quontation/result`, data);
        setDataList(response.data);
        //console.log(response.data);
        setLoading(false);
    }

    const handleQuickSearch = (event) => {
        const { name, value } = event.target;
        handleSetCondition('company_name', value);
    }

    const handleSetCondition = (name, value) => {
        setCondition(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetPagination = (name, value) => {
        setPagination(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSetSearch = (name, value) => {
        setSearch(prevData => {
            return { ...prevData, [name]: value };
        });
    }

    const handleSizeTableChange = (event) => {
        const { name, value } = event.target;
        handleSetSearch('page', 1);
        handleSetSearch('size', value);
    }
    const handlePagingChange = (page_no) => {
        handleSetSearch('page', page_no);
    }

    const handleOpenDetail = (quontation_id) => {
        navigate(`/paypendding/${quontation_id}/detail`);
    }

    useEffect(() => {
        getQuontation();
    }, [])
    useEffect(() => {
        //console.log(search)
        getQuontation();
    }, [search, condition])

    return (
        <Layout4Admin1 role="admin">
            <div className={Css.Topic}>
                ข้อมูลการขอใช้บริการระบบ DCaaS
            </div>
            <div className={Css.Block_Transparent}>
                <div className={Css.Graph_Group}>
                    <div className={Css.Graph_Box}>
                        <div className={Css.Content}>
                            <div className={Css.Header + ' d-flex'}>
                                <h6 className="d-flex align-items-center">รายการรอตรวจสอบ</h6>
                                <div className="flex-fill">
                                    <Form.Group as={Row}>
                                        <Form.Label column sm={4} className="text-end">ค้นหา</Form.Label>
                                        <Col>
                                            <InputGroup>
                                                <Form.Control placeholder="ชื่อผู้ขอใข้บริการ" id={'txtQuickSearch'} name={'company_name'} value={condition.company_name} onChange={(event) => handleQuickSearch(event)} />
                                                <Button variant="outline-secondary">
                                                    <i className="fa-solid fa-arrow-down-short-wide"></i>
                                                    <span></span>
                                                </Button>
                                                <Button>
                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                </Button>
                                            </InputGroup>

                                        </Col>
                                    </Form.Group>

                                </div>
                            </div>
                            <div className={Css.Content}>
                                <div className="table-responsive border rounded">
                                    <Table className="table">
                                        <thead className="table-light">
                                            <tr>
                                                <th></th>
                                                <th>#</th>
                                                <th>หมายเลขอ้างอิง</th>
                                                <th>สถานะชำระ</th>
                                                <th>ตรวจสอบชำระ</th>
                                                <th>ชื่อลูกค้า</th>
                                                <th>แพ็คเกจ</th>
                                                <th>ราคา</th>
                                                <th>วันที่ทำรายการ</th>
                                                <th>วันที่ครบกำหนดชำระ</th>
                                                <th>วันที่ชำระ</th>
                                                <th>ช่องทางชำระ</th>
                                                <th>จำนวนเงินชำระ</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                loading == false &&
                                                dataList.map((obj, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>
                                                                <button type={'button'} className="btn btn-outline-primary me-1" title="รีวิว" onClick={event => handleOpenDetail(obj.quontation_number)}>
                                                                    <i className="fa-solid fa-magnifying-glass"></i>
                                                                </button>
                                                            </td>
                                                            <td>{index + 1}</td>
                                                            <td>{obj.quontation_number}</td>
                                                            <td>{obj.payment_status_name}</td>
                                                            <td>{(obj.is_audit === null) ? 'รออนุมัติ' : (obj.is_audit === true) ? 'อนุมัติ' : 'ไม่อนุมัติ'}</td>

                                                            <td>{obj.company_name}</td>
                                                            <td>{obj.package_master_name_short}</td>
                                                            <td>{AddCommar(obj.total)}</td>
                                                            <td>{ConvertDateTimeToText(obj.create_date)}</td>
                                                            <td>{ConvertDateTimeToText(obj.due_date)}</td>
                                                            <td>{ConvertDateTimeToText(obj.paid_date)}</td>
                                                            <td>{obj.payment_method_name}</td>
                                                            <td>{AddCommar(obj.paid_amount)}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </Table>

                                </div>
                                <DisplayPaging rec_start={pagination.record_start}
                                    rec_end={pagination.record_end}
                                    rec_count={pagination.record_count}
                                    onSizeChange={handleSizeTableChange}
                                    cur_page={search.page}
                                    size={search.size}
                                    page_count={pagination.page_count}
                                    onPagingChange={handlePagingChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer4Bottom1 />
        </Layout4Admin1>
    )
}